import React from "react";
import { Link } from "react-router-dom";
import { Card } from "react-bootstrap";
import Rating from "./Rating";

/* Friendly labels for genero codes (DB stores: dama|caballero|unisex) */
const generoLabel = (g) => {
  if (g === "dama") return "DAMA";
  if (g === "caballero") return "CABALLERO";
  if (g === "unisex") return "UNISEX";
  return "";
};

const Product = ({ product }) => {
  // Compose the kicker line "DAMA · FLORAL" only when we actually have data.
  const kickerParts = [];
  if (product.tipo === "perfumes" && product.genero) {
    kickerParts.push(generoLabel(product.genero));
  }
  if (product.profile) kickerParts.push(product.profile.toUpperCase());
  const kicker = kickerParts.filter(Boolean).join(" · ");

  return (
    <Card style={{ minHeight: "42vh" }} className="my-1 p-3 rounded h-100 hadacy-product-card">
      <style>{`
        .hadacy-product-card .hpc-kicker {
          font-size: 0.62rem;
          letter-spacing: 0.22em;
          text-transform: uppercase;
          color: #b8933a;
          margin-bottom: 0.25rem;
          display: block;
        }
        .hadacy-product-card .hpc-inspo {
          font-family: "Cormorant Garamond", "Playfair Display", serif;
          font-style: italic;
          font-size: 0.92rem;
          color: #7a6e62;
          margin: 0.1rem 0 0.1rem;
          display: block;
        }
        .hadacy-product-card .hpc-brand {
          font-size: 0.7rem;
          letter-spacing: 0.2em;
          text-transform: uppercase;
          color: #a59786;
          margin-bottom: 0.4rem;
          display: block;
        }
        .hadacy-product-card .hpc-volume {
          display: inline-block;
          margin-left: 0.5rem;
          padding: 0.15rem 0.55rem;
          border: 1px solid rgba(184,147,58,0.28);
          border-radius: 999px;
          font-size: 0.62rem;
          letter-spacing: 0.18em;
          color: #7a6e62;
          vertical-align: middle;
        }
        .hadacy-product-card .hpc-notes {
          display: flex;
          flex-wrap: wrap;
          gap: 0.3rem;
          margin-top: 0.45rem;
        }
        .hadacy-product-card .hpc-note-tag {
          font-size: 0.58rem;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          padding: 0.18rem 0.5rem;
          border: 1px solid rgba(184,147,58,0.28);
          color: #b8933a;
          border-radius: 1px;
        }
      `}</style>

      <Link to={`/product/${product._id}`}>
        <div className="wrapper">
          <Card.Img
            style={{ borderRadius: "20%" }}
            src={product.image}
            variant="top"
          ></Card.Img>
        </div>
      </Link>
      <Card.Body>
        {kicker && <span className="hpc-kicker">{kicker}</span>}

        <Link to={`/product/${product._id}`}>
          <Card.Title as="div">
            {" "}
            <strong>{product.name}</strong>{" "}
          </Card.Title>
        </Link>

        {product.inspo && (
          <span className="hpc-inspo">inspirado en {product.inspo}</span>
        )}
        {product.brand && product.tipo === "perfumes" && (
          <span className="hpc-brand">{product.brand}</span>
        )}

        <Card.Text as="div">
          <Rating
            value={product.rating}
            text={`${product.numReviews} reviews`}
          ></Rating>
        </Card.Text>

        <Card.Text as="h3">
          ${product.price.toFixed(2)}
          <span style={{ fontSize: 12 }}>(MXN)</span>
          {product.volume && <span className="hpc-volume">{product.volume}</span>}
        </Card.Text>

        {Array.isArray(product.notes) && product.notes.length > 0 && (
          <div className="hpc-notes">
            {product.notes.slice(0, 4).map((n) => (
              <span className="hpc-note-tag" key={n}>
                {n}
              </span>
            ))}
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

// ` se refiere a template strings  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals

export default Product;
